import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

interface Props {
  flexDirection?: 'row' | 'column';
}

export const LoadingPage: React.FC<Props> = ({ flexDirection = 'column' }) => (
  <Box
    className='loading'
    style={{ flexDirection: `${flexDirection || 'column'}` }}
  >
    <CircularProgress />
    <Typography sx={{ m: '20px 0 20px 3px' }}>로딩중...</Typography>
  </Box>
);
